import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppConfiguration } from 'src/app/app.configuration';
import { InitService } from 'src/app/core/init/init.service';
import { EspectaculosService } from '../../espectaculos-butacas/espectaculos.service';
import { ButacasService } from '../../espectaculos-butacas/mapa/servicios/butacas.service';
import { ProductosService } from '../../productos.service';
import { CalendarService } from '../../ticket-sales/pages/date-selector/calendar/calendar.service';
import { IEnlaceMenuPadre } from '../../productos.service.interface';
import { ConfigurationService } from 'src/app/core/config/configuration.service';
import { UserService } from 'src/app/user/user.service';

@Component({
  selector: 'app-producto-padre',
  templateUrl: './producto-padre.component.html',
  styleUrls: ['./producto-padre.component.scss']
})
export class ProductoPadreComponent implements OnInit, OnDestroy {
  /* espectaculos;
  todosEspectaculos;
  totalEspectaculos;
  backupEspectaculos;
  espectaculosSub: Subscription;
  todosEspectaculosSub: Subscription;
  backupEspectaculosSub: Subscription; */
  @Input() isEspectaculos: boolean = false; // Indica si se trata de espectáculos
  filtrarSub: Subscription;
  proyecto = this.config.getProyecto();
  backupProductosPadreSub: Subscription;
  backupProductosPadre: IEnlaceMenuPadre[];
  productosPadreSub: Subscription;
  productosPadre: IEnlaceMenuPadre[];
  configurationSub: Subscription;
  verAreaCliente: number = 0; // Variable para mostrar el área cliente, por defecto es 0 (no mostrar)
  
  constructor(
    private productosService: ProductosService,
    private config: AppConfiguration,
    private initService: InitService,
    private calendarService: CalendarService,
    private router: Router,
    private butacasService: ButacasService,
    private espectaculoService: EspectaculosService,
    private configurationService: ConfigurationService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    
    this.configurationSub = this.configurationService.configuration$.subscribe(config => {
      if (config && config !== undefined && config !== null && config.datosProyecto) {
        this.verAreaCliente = this.configurationService.getCaracteristicasAdicionalesProyecto().MostrarAreaCliente || 0;
      }
    });

    this.productosPadreSub = this.productosService.enlacesMenuPadre$.subscribe(() => {
      this.productosPadre = this.productosService.enlacesMenuPadreValue;
    });

    this.backupProductosPadreSub = this.productosService.backupProductosPadre$.subscribe(() => {
      this.backupProductosPadre = this.productosService.backupProductosPadreValue;
    });

    this.filtrarSub = this.productosService.filtroProductos$.subscribe(filtro => {
      if (filtro && filtro.length > 0) {
        this.productosPadre = this.backupProductosPadre;
        this.productosPadre = this.productosPadre.filter(p => p.chNombre.toLowerCase().includes(filtro));
      } else {
        this.productosPadre = this.backupProductosPadre;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.backupProductosPadreSub) this.backupProductosPadreSub.unsubscribe();
    if (this.productosPadreSub) this.productosPadreSub.unsubscribe();
  }

  onImgError(event) {
    event.target.src = 'assets/img/' + this.proyecto + '/catalog-padre/default_catalog.png';
  }

  irProductoPadre(producto: IEnlaceMenuPadre) {
    this.router.navigate(['/tienda/productos/children/' + producto.pkid]);
  }

  getProductosPadreOrdered() {
    console.log({
      action: 'getProductosPadreOrdered',
      isEspectaculos: this.isEspectaculos,
      verAreaCliente: this.verAreaCliente,
      user: this.userService.currentUserValue,
      productosPadre: this.productosPadre
    })
    if (!this.verAreaCliente) {

      //Only enlace Menu with iNivel 0
      /* New */
      const enlacesMenuNivel = this.productosPadre.filter(em => +em.iNivel === 0);
      const enlacesMenu = enlacesMenuNivel.filter(em => {
        const caracteristicasAdicionales = em.CaracteristicasAdicionales ? JSON.parse(em.CaracteristicasAdicionales) : null;

        const isEmEspectaculo = caracteristicasAdicionales
        ? +caracteristicasAdicionales?.CaracteristicasAdicionales?.VerEspectaculos === 1
        : false;
        console.log({
          action: 'getProductosPadreOrdered - caracteristicasAdicionales',
          caracteristicasAdicionales: caracteristicasAdicionales,
          em: em,
          isEmEspectaculo: isEmEspectaculo
        })
        
        if (this.isEspectaculos) {
          return isEmEspectaculo && (+em.iLogueo < 0);
        } else {
          return !isEmEspectaculo && (+em.iLogueo < 0);
        }
      });

      console.log({
        action: 'getProductosPadreOrdered - enlacesMenu',
        enlacesMenuParsed: enlacesMenu,
      })

      const enlacesMenuOrdered = enlacesMenu.sort((a, b) => {
        return +a.iOrden - +b.iOrden;
      });

      return enlacesMenuOrdered;
    }
    if (this.verAreaCliente && !this.userService.currentUserValue) {

      //Only enlace Menu with iNivel 0
      /* New */
      const enlacesMenuNivel = this.productosPadre.filter(em => +em.iNivel === 0);
      const enlacesMenu = enlacesMenuNivel.filter(em => +em.iLogueo < 1 || +em.iLogueo === 3);

      const enlacesMenuByEm = enlacesMenu.filter(em => {
        const caracteristicasAdicionales = em.CaracteristicasAdicionales ? JSON.parse(em.CaracteristicasAdicionales) : null;
        const isEmEspectaculo = caracteristicasAdicionales
          ? +caracteristicasAdicionales?.CaracteristicasAdicionales?.VerEspectaculos === 1
          : false;

        return this.isEspectaculos ? isEmEspectaculo : !isEmEspectaculo;
      });
      
      const enlacesMenuOrdered = enlacesMenuByEm.sort((a, b) => {
        return +a.iOrden - +b.iOrden;
      });

      return enlacesMenuOrdered;
    }

    return [];
  }
}
